/* eslint-disable react/no-unknown-property */
/** @jsxImportSource @compiled/react */

import { css } from '@compiled/react';
import React from 'react';

export const CommunityLogo = () => (
  <svg
    css={svgStyles}
    xmlns="http://www.w3.org/2000/svg"
    width="127"
    height="24"
    viewBox="0 0 127 24"
    fill="none">
    <path
      d="M119.728 17.303H118.315L113.75 5.33594H116.07L120.106 16.2801L124.141 5.33594H126.462L121.695 17.7121C120.282 21.3687 119.475 23.2609 116.272 23.2609C115.188 23.2609 114.582 23.1586 113.952 22.9029V21.0107C114.683 21.2408 115.516 21.3176 116.146 21.3176C117.912 21.3176 118.693 20.0902 119.728 17.303Z"
      fill="#101214"
    />
    <path
      d="M109.789 14.1534C109.789 15.2785 110.444 16.0457 111.781 16.0457C112.286 16.0457 112.765 15.9434 113.143 15.8667V17.989C112.765 18.0913 112.336 18.1936 111.68 18.1936C108.981 18.1936 107.67 16.5826 107.67 14.2046V7.37722H105.627V5.33158H107.67V2.62109H109.789V5.33158H113.143V7.37722H109.789V14.1534Z"
      fill="#101214"
    />
    <path
      d="M100.939 1.96002C100.939 0.988335 101.57 0.425781 102.453 0.425781C103.336 0.425781 103.966 0.988335 103.966 1.96002C103.966 2.9317 103.336 3.49425 102.453 3.49425C101.57 3.49425 100.939 2.9317 100.939 1.96002ZM101.343 18.1206V5.33533H103.512V18.1206H101.343Z"
      fill="#101214"
    />
    <path
      d="M98.3189 10.6269V18.1191H96.1498V10.3968C96.1498 8.09545 95.2419 7.07263 93.1737 7.07263C91.1559 7.07263 89.7687 8.42787 89.7687 11.0105V18.1191H87.5996V5.33383H89.7687V7.43062C90.5758 5.92195 92.0639 5.07812 93.7538 5.07812C96.6543 5.07812 98.3189 7.0982 98.3189 10.6269Z"
      fill="#101214"
    />
    <path
      d="M73.6016 12.8281V5.33594H75.7707V13.0583C75.7707 15.3596 76.6786 16.3824 78.7468 16.3824C80.7646 16.3824 82.1518 15.0272 82.1518 12.4446V5.33594H84.3209V18.1212H82.1518V16.0244C81.3447 17.5331 79.8566 18.3769 78.1667 18.3769C75.2662 18.3769 73.6016 16.3569 73.6016 12.8281Z"
      fill="#101214"
    />
    <path
      d="M62.2838 11.0105V18.1191H60.1147V10.3968C60.1147 8.09545 59.2067 7.07263 57.1385 7.07263C55.1207 7.07263 53.7335 8.42787 53.7335 11.0105V18.1191H51.5645V5.33383H53.7335V7.43062C54.5406 5.92195 56.0287 5.07812 57.7186 5.07812C59.8625 5.07812 61.3253 6.17766 61.9559 8.19774C62.6621 6.2288 64.352 5.07812 66.4454 5.07812C69.2703 5.07812 70.834 7.02149 70.834 10.6269V18.1191H68.6649V11.0105C68.6649 8.37673 67.7569 7.07263 65.6887 7.07263C63.671 7.07263 62.2838 8.42787 62.2838 11.0105Z"
      fill="#101214"
    />
    <path
      d="M39.9928 11.0105V18.1191H37.8237V10.3968C37.8237 8.09545 36.9157 7.07263 34.8475 7.07263C32.8297 7.07263 31.4425 8.42787 31.4425 11.0105V18.1191H29.2734V5.33383H31.4425V7.43062C32.2496 5.92195 33.7377 5.07812 35.4276 5.07812C37.5715 5.07812 39.0343 6.17766 39.6649 8.19774C40.3711 6.2288 42.061 5.07812 44.1544 5.07812C46.9792 5.07812 48.543 7.02149 48.543 10.6269V18.1191H46.3739V11.0105C46.3739 8.37673 45.4659 7.07263 43.3977 7.07263C41.38 7.07263 39.9928 8.42787 39.9928 11.0105Z"
      fill="#101214"
    />
    <path
      d="M20.7997 18.3748C17.0164 18.3748 14.7969 15.5365 14.7969 11.7009C14.7969 7.86532 17.0164 5.07812 20.7997 5.07812C24.5578 5.07812 26.7521 7.86532 26.7521 11.7009C26.7521 15.5365 24.5578 18.3748 20.7997 18.3748ZM20.7997 7.12377C18.1009 7.12377 16.9155 9.2717 16.9155 11.7009C16.9155 14.1301 18.1009 16.3292 20.7997 16.3292C23.4732 16.3292 24.6334 14.1301 24.6334 11.7009C24.6334 9.2717 23.4732 7.12377 20.7997 7.12377Z"
      fill="#101214"
    />
    <path
      d="M13.2066 15.1558V17.3804C12.1725 18.0708 10.5331 18.3777 8.81798 18.3777C3.37004 18.3777 0.292969 15.0535 0.292969 9.76041C0.292969 4.64629 3.37004 1.06641 8.76754 1.06641C10.3817 1.06641 11.9959 1.37325 13.1814 2.24265V4.46729C11.9959 3.70018 10.6844 3.29105 8.76754 3.29105C4.88336 3.29105 2.56294 5.89925 2.56294 9.76041C2.56294 13.6216 4.95903 16.1786 8.89365 16.1786C10.634 16.1786 11.9959 15.7695 13.2066 15.1558Z"
      fill="#101214"
    />
  </svg>
);

const svgStyles = css({
  width: '100%',
  height: '100%',
});
